export const showInMobileView = 'mantine-hidden-from-xs'
export const showInDesktopView = 'mantine-visible-from-xs'